const offerAgent = [
    {
        path: "/offer-agent",
        redirect: "/offerdocuments",
    },
    {
        path: "/offer-agent/add",
        name: "offer-agent-add",
        component: () => import("@/views/offer-document-agent/OfferAgentForm.vue"),
        meta: {
            title: "Add Agent Offer",
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
    {
        path: "/offer-agent/edit/:uuid",
        name: "offer-agent-edit",
        component: () => import("@/views/offer-document-agent/OfferAgentForm.vue"),
        meta: {
            title: "Edit Agent Offer",
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
    {
        path: "/offer-agent/detail/:uuid",
        name: "offer-agent-detail",
        component: () => import("@/views/offer-document-agent/OfferAgentDetail.vue"),
        meta: {
            title: "Agent Offer Detail",
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
];

export default offerAgent;
